import React from "react";
import unchecked_icon from "../../../images/gameplay_ui/icons/sort_train/icon_uncheked.svg";
import checked_icon from "../../../images/gameplay_ui/icons/sort_train/icon_cheked.svg";
export default class SortTrainCarWindow_UnloadToggle extends React.Component{
    render() {
        let mainStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: "10px"
        }
        let textStyle = {
            fontWeight: "bold",
            textTransform: "uppercase"
        }
        let iconStyle = {
            paddingTop: "5px"
        }
        return <div style={mainStyle}>
            <div style={textStyle}>Выгрузить</div>
            <img alt={'icon'} style={iconStyle} src={this.props.isLoaded ? checked_icon : unchecked_icon}/>
        </div>
    }
}
